import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'src/redux/store'
import { getListMegaMenu, updateMegaMenu } from 'src/redux/actions/mega-menu'
import { clearError, resetState } from 'src/redux/Slices/mega-menu'
import { IUpdateMegaMenuValue } from 'src/interfaces/mega-menu'

export const useMegaMenuActions = () => {
  const dispatch = useAppDispatch()

  const fetchMegaMenus = useCallback(() => {
    return dispatch(getListMegaMenu())
  }, [dispatch])

  const updateMegaMenuItem = useCallback(
    (id: number, data: IUpdateMegaMenuValue) => {
      return dispatch(updateMegaMenu({ id, data }))
    },
    [dispatch]
  )

  const clearMegaMenuError = useCallback(() => {
    dispatch(clearError())
  }, [dispatch])

  const resetMegaMenuState = useCallback(() => {
    dispatch(resetState())
  }, [dispatch])

  return {
    fetchMegaMenus,
    updateMegaMenuItem,
    clearMegaMenuError,
    resetMegaMenuState,
  }
}

export const useMegaMenuSelectors = () => {
  const megaMenus = useAppSelector((state) => state.megaMenu.megaMenus)
  const loading = useAppSelector((state) => state.megaMenu.loading)
  const error = useAppSelector((state) => state.megaMenu.error)
  const updateLoading = useAppSelector((state) => state.megaMenu.updateLoading)
  const updateError = useAppSelector((state) => state.megaMenu.updateError)

  return {
    megaMenus,
    loading,
    error,
    updateLoading,
    updateError,
  }
}
